/* Каруселът с проектите се плъзга сам настрани, без край.
   Спира: при посочване с мишка, при влачене или плъзгане с пръст (и още 1,8 s след това),
   при фокус от клавиатура, когато е извън екрана, когато табът е скрит,
   и изобщо не тръгва при prefers-reduced-motion.
   Картите се дублират веднъж, за да няма край; копията са скрити от екранни четци и от Tab.
   Ако GSAP е зареден, върви по неговия ticker; иначе по requestAnimationFrame.

   window.NXAuto — малко API за влаченето с мишка (nx-motion-carousel.js):
     ensure(wrap)   → пуска карусела веднага (дублира картите), ако още не е; true/false
     pause(wrap)    → спира самоплъзгането, докато някой друг движи лентата
     resume(wrap)   → поема позицията обратно и тръгва пак след обичайните 1,8 s
     setX(wrap, x)  → слага позиция, завъртяна по модул на ширината на кръга; връща я
     getX(wrap)     → текущата позиция (с дробната част, която scrollLeft губи)
     loopW(wrap)    → ширината на един кръг (оригиналите), 0 ако няма кръг
     wrapX(x, L)    → x по модул L, винаги в [0, L) */
(function () {
  if (window.__nxAutoScroll) return;
  window.__nxAutoScroll = true;
  var REDUCED = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

  var SPEED = 38;      // пиксела в секунда
  var RESUME = 1800;   // ms след последното докосване, преди да тръгне пак
  var items = [];
  var running = false;

  // без „(x % L + L) % L" — то добавя шум в дробната част и при стойности вътре в кръга
  function wrapX(x, L) {
    if (!(L > 0)) return x;
    var r = x % L;
    if (r < 0) r += L;
    return r >= L ? 0 : r;
  }
  function find(wrap) {
    for (var i = 0; i < items.length; i++) if (items[i].wrap === wrap) return items[i];
    return null;
  }

  function init(wrap) {
    if (REDUCED) return null;   // без кръг и без самоплъзгане; влаченето си работи и така
    var had = find(wrap);
    if (had || wrap.dataset.nxAuto) return had;
    var track = wrap.querySelector('.cases');
    if (!track) return null;
    var cards = Array.prototype.slice.call(track.children).filter(function (c) {
      return c.classList.contains('case-card');
    });
    if (cards.length < 3) return null;
    wrap.dataset.nxAuto = '1';

    cards.forEach(function (c) {
      var k = c.cloneNode(true);
      k.classList.add('is-clone');
      k.setAttribute('aria-hidden', 'true');
      k.setAttribute('tabindex', '-1');
      track.appendChild(k);
    });
    var first = cards[0];
    var firstClone = track.children[cards.length];

    wrap.style.scrollSnapType = 'none';   // снаповете дърпат назад при всяко плавно помръдване

    var s = { wrap: wrap, x: wrap.scrollLeft, lastSet: wrap.scrollLeft,
              hold: 0, hover: false, focus: false, visible: true, paused: false,
              loopW: function () { return firstClone.offsetLeft - first.offsetLeft; } };
    function touched() { s.hold = performance.now() + RESUME; }

    wrap.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') s.hover = true; });
    wrap.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') s.hover = false; });
    wrap.addEventListener('pointerdown', touched, { passive: true });
    wrap.addEventListener('touchstart', touched, { passive: true });
    wrap.addEventListener('wheel', touched, { passive: true });
    wrap.addEventListener('focusin', function () { s.focus = true; });
    wrap.addEventListener('focusout', function () { s.focus = false; });
    // скрол, който не сме направили ние = човек плъзга (включително инерцията след пръста)
    wrap.addEventListener('scroll', function () {
      if (s.paused) return;
      if (Math.abs(wrap.scrollLeft - s.lastSet) > 2) { touched(); s.x = wrap.scrollLeft; }
    }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { s.visible = es[0].isIntersecting; }).observe(wrap);
    }
    items.push(s);
    run();
    return s;
  }

  function step(dt) {
    var now = performance.now();
    for (var i = 0; i < items.length; i++) {
      var s = items[i], w = s.wrap;
      // редакторът на темата сменя секцията — старата лента вече я няма
      if (w.isConnected === false) { items.splice(i--, 1); continue; }
      if (s.paused || !s.visible || s.hover || s.focus || document.hidden || w.classList.contains('dragging')) continue;
      if (now < s.hold) { s.x = w.scrollLeft; continue; }
      var L = s.loopW();
      if (L <= 0) continue;
      s.x = wrapX(s.x + SPEED * dt, L);
      w.scrollLeft = s.x;
      s.lastSet = w.scrollLeft;
    }
  }

  // един-единствен цикъл за всички карусели; пуска се с първия
  function run() {
    if (running) return;
    running = true;
    if (window.gsap && gsap.ticker) {
      gsap.ticker.add(function (t, deltaMs) { step(Math.min(0.05, deltaMs / 1000)); });
    } else {
      var last = performance.now();
      (function raf(now) {
        step(Math.min(0.05, (now - last) / 1000)); last = now;
        requestAnimationFrame(raf);
      })(last);
    }
  }

  window.NXAuto = {
    ensure: function (wrap) { return !!(wrap && init(wrap)); },
    pause: function (wrap) { var s = find(wrap); if (s) s.paused = true; },
    resume: function (wrap) {
      var s = find(wrap);
      if (!s) return;
      s.paused = false;
      s.x = wrapX(wrap.scrollLeft, s.loopW());
      // лентата е два еднакви кръга — прехвърлянето в първия не се вижда, а пази x и scrollLeft в съгласие
      if (Math.abs(wrap.scrollLeft - s.x) > 1) wrap.scrollLeft = s.x;
      s.lastSet = wrap.scrollLeft;
      s.hold = performance.now() + RESUME;
    },
    setX: function (wrap, x) {
      var s = find(wrap);
      if (s) x = wrapX(x, s.loopW());
      wrap.scrollLeft = x;
      if (s) { s.x = x; s.lastSet = wrap.scrollLeft; }
      return x;
    },
    getX: function (wrap) {
      var s = find(wrap);
      // s.x пази дробната част; ако някой е мръднал лентата отвън, вярваме на scrollLeft
      return s && Math.abs(s.x - wrap.scrollLeft) < 2 ? s.x : wrap.scrollLeft;
    },
    loopW: function (wrap) { var s = find(wrap); return s ? s.loopW() : 0; },
    wrapX: wrapX
  };

  function start() {
    document.querySelectorAll('.cases-wrap').forEach(init);
  }

  // DOMContentLoaded идва след всички defer скриптове — картите на devices.js вече са вътре
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // редакторът на темата презарежда секцията сама
  document.addEventListener('shopify:section:load', function (e) {
    var w = e.target.querySelector('.cases-wrap');
    if (w) { init(w); }
  });
})();
